export const SAVE_BRANDS = 'SAVE_BRANDS';

export const BrandsReducer = (state, action) => {
  switch (action.type) {
    case SAVE_BRANDS:
      return action.payload;
    default:
      return state;
  }
};
